import { FunctionComponent, useCallback, useEffect, useRef } from 'react';

import { SCRIPT_BUNDLE } from './constants';
import { FRONT_ENVIRONMENT_KEY } from '~/config';

const FrontChatWidget: FunctionComponent = function () {
  const timerRef = useRef<NodeJS.Timer | null>(null);
  const init = useCallback(() => {
    if (!window.FrontChat) {
      timerRef.current = setTimeout(() => init(), 100);
      return;
    }
    clearTimeout(timerRef.current as unknown as number);
    window.FrontChat('init', {
      chatId: FRONT_ENVIRONMENT_KEY,
      useDefaultLauncher: false,
    });
  }, []);

  const bundleRef = useRef<boolean>(false);
  useEffect(() => {
    if (bundleRef.current) return;
    const s1 = document.createElement('script');
    s1.type = 'text/javascript';
    s1.src = SCRIPT_BUNDLE;
    document.head.appendChild(s1);

    init();
  }, [init]);

  return null;
};

export default FrontChatWidget;
